import { Document } from '@tiptap/extension-document'
import { Heading, type Level } from '@tiptap/extension-heading'
import { Text } from '@tiptap/extension-text'
import { Bold } from '@tiptap/extension-bold'
import { Italic } from '@tiptap/extension-italic'
import { Strike } from '@tiptap/extension-strike'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Typography } from '@tiptap/extension-typography'
import { CodeBlock } from '@tiptap/extension-code-block'
import { Blockquote } from '@tiptap/extension-blockquote'
import { ListItem } from '@tiptap/extension-list-item'
import { OrderedList } from '@tiptap/extension-ordered-list'
import { BulletList } from '@tiptap/extension-bullet-list'
import { HorizontalRule } from '@tiptap/extension-horizontal-rule'
import { HardBreak } from '@tiptap/extension-hard-break'
import { Underline } from '@tiptap/extension-underline'
import { Code } from '@tiptap/extension-code'
import { Subscript } from '@tiptap/extension-subscript'
import { Superscript } from '@tiptap/extension-superscript'
import { Link } from '@tiptap/extension-link'
import { Caption, File, Files } from '~/tiptap/files'
import { Youtube } from '~/tiptap/youtube'
import { HighLightSection } from '~/tiptap/highlight-section'
import { UserMention } from '~/tiptap/mention'
import { Twemoji } from '~/tiptap/twemoji'

// beware extension configuration for tiptap

export const titleExtensions = (options?: Partial<{
  customHeadingLevel?: Level
}>) => {
  return markRaw([
    // nodes
    Document.configure({
      content: 'heading',
    }),
    Heading.configure({
      levels: [options?.customHeadingLevel || 1],
    }),
    Text,
    Twemoji,
    Typography,
  ])
}

export const teaserExtensions = () => markRaw([
  // nodes
  Document,
  Paragraph,
  Text,
  Twemoji,
  UserMention,
  // marks
  Bold,
  Italic,
  Strike,
  Typography,
])

export const bodyExtensions = () => markRaw([
  // nodes
  Document,
  Heading.configure({
    levels: [2, 3, 4],
  }),
  Text,
  Paragraph,
  CodeBlock,
  Blockquote,
  ListItem,
  OrderedList,
  BulletList,
  HorizontalRule,
  Twemoji,
  HighLightSection,
  HardBreak,
  UserMention,
  Youtube.configure({
    nocookie: true,
  }),
  Files, File, Caption,
  // marks
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Subscript,
  Superscript,
  Link.configure({
    openOnClick: false,
  }),
])
